export const allStates = [
  // Canada
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Northwest Territories",
  "Nunavut",
  "Yukon",

  // USA
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",

  // Mexico
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Coahuila",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Mexico City",
  "Mexico State",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatan",
  "Zacatecas",
];
export const currencies = ["CAD", "USD"];
export const customersType = ["Shipper", "Broker", "Carrier", "Other"];
export const countries = ["Canada", "USA", "Mexico"];
export const billingOptions = ["Shipper", "Consignee", "Third Party"];
export const ServicesSelection = [
  "Default App",
  "YRC",
  "Conway",
  "Fedex",
  "Freightcom",
  "Day & Ross",
  "Old Dominion",
  "Manitoulin",
  "SAIA",
  "ABF",
  "Dayton",
  "R and L",
  "Fr8nex",
  "Rate Card",
  "Freight Rater",
  "Carrier Connector",
  "Project 44",
  "GreenSceens",
  "CustomCapacity",
];

export const driverTypes = ["company driver", "owner operator"];
export const payTypes = [
  {
    key: "flatRate",
    value: "Flat Rate",
    uuid: "f47ac10b-58cc-4372-a567-0e02b2c3d479",
  },
  {
    key: "payPerStop",
    value: "Pay Per Stop",
    uuid: "c0a801c8-90a0-4d73-bd87-b0c6ec82be2b",
  },
  {
    key: "payPerMile",
    value: "Pay Per Mile",
    uuid: "b9875c22-d74d-490d-8a42-32e679e4ad8f",
  },
  {
    key: "payPerHour",
    value: "Pay Per Hour",
    uuid: "e9b2f88d-cf4f-4962-a8d9-125a6d1d2bb2",
  },
  {
    key: "payPerWeight",
    value: "Pay Per Weight",
    uuid: "fbd1de88-0eb0-44b1-b9e1-593b8cf9d228",
  },
  {
    key: "percentGrossRevenue",
    value: "% Gross Revenue",
    uuid: "8e564c1f-0160-42c7-98f6-df79d7c9f4c1",
  },
  {
    key: "percentAllocatedRevenue",
    value: "% Allocated Revenue",
    uuid: "9b7d53ad-d9b6-4266-a06c-9c41e65e29bb",
  },
];
export const payAccessoarials = [
  {
    key: "flatRate",
    value: "Flat Rate",
    uuid: "f47ac10b-58cc-4372-a567-0e02b2c3d479",
  },
  {
    key: "grossRevenue",
    value: "% gross Revenue",
    uuid: "f47ac10b-58cc-4372-a567-0e02b2c3d479",
  },
  {
    key: "allocatedRevenue",
    value: "% Allocated Revenue",
    uuid: "f47ac10b-58cc-4372-a567-0e02b2c3d479",
  },
];

export const colors = [
  "bg-red-500",
  "bg-green-500",
  "bg-blue-500",
  "bg-yellow-500",
  "bg-purple-500",
  "bg-pink-500",
];
